<template>
    <div>
        <div class="col-lg-12 mb-4">
            <div class="applicant-nav-tabs">
                <ul class="nav nav-tabs nav-tabs-empl" id="myTab" role="tablist">
                    <li class="nav-item" v-for="(tab,index) in tabs">
                        <a
                            :class="[`nav-link `, {'active': activeTabIndex === index}]"
                            :id="`tab-${index}`"
                            data-toggle="tab"
                            :href="`#${tab}`"
                            role="tab"
                            aria-controls="home"
                            aria-selected="false"
                            @click="setActiveTab(tab)"
                        >
                            {{ tab }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="tab-content" id="myTabContent">

                    <div v-for="(tab,index) in tabs"
                         :class="[`tab-pane fade`, {'show active': activeTabIndex === index}]"
                         :id="tab"
                         role="tabpanel"
                         :aria-labelledby="`tab-${index}`"
                    >
                        <component
                            :is="getComponentName(tab)"
                            :clientInfo="client"
                        ></component>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BannedEmployees from "./Tabs/BannedEmployees.vue";
import CallOut from "./Tabs/CallOut.vue";
import EditSite from "./Tabs/EditSite.vue";
import Notes from "./Tabs/Notes.vue";
import Positions from "./Tabs/Positions.vue";
import TabsHandler from "../../../../../resources/js/mixins/TabsHandler";

export default {
    name: 'ClientTabsContainer',
    mixins: [TabsHandler],
    props: {
        client: {
            type: Object,
            required: true,
        }
    },
    components: {
        Notes,
        Positions,
        EditSite,
        CallOut,
        BannedEmployees,
    },
    data() {
        return {
            selectedTab: null,
            activeTabIndex: 0,
            tabs: [
                'Edit Site',
                'Positions',
                'Notes',
                'Call Out',
                'Banned Employees',
            ]
        }
    },
    mounted() {
        this.getActiveTab();

    }
}

</script>

<style scoped>

</style>
